import React, {useEffect, useState}from 'react';
import { goodsauth } from '../../utils/tool';
import { goodsauthtwo } from '../../utils/tooltwo';
import { useHistory } from "react-router-dom";
import {Toast } from 'antd-mobile'
import { Modal } from 'antd-mobile'
import style from './style.module.css'

export default () => {
    let route = useHistory();
    let [payed, setPayed] = useState(true)
    let payShow = sessionStorage.getItem('payshow')

    // // 判断用户是否购买商品
    useEffect(() => {
        let countNum = sessionStorage.getItem('count');
        sessionStorage.setItem('count',parseInt(countNum) + 1);
        if(sessionStorage.getItem('count') >= 1){
            setPayed(() => true)
        }
    },[])
    // 判断是否购买
    function payment(){
        let userMemberId = sessionStorage.getItem('member_id') || localStorage.getItem('member_id');
        // let userMemberId = 1132421922;
        Toast.loading('查询中...',0);

        if(sessionStorage.getItem('url') === 'p1'){
            goodsauth(userMemberId).then((res) => {
                Toast.hide()
                if(res.code != 1){
                    if(sessionStorage.getItem('url') === 'p1'){
                        route.push({pathname: '/p1',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }else if(sessionStorage.getItem('url') === 'p2' || localStorage.getItem('url') === 'p2'){
                        route.push({pathname: '/p2',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }else {
                        route.push({pathname: '/p3',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }
                }else{
                    // window.gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
                    route.replace({pathname: '/result',search:"member_id=" + localStorage.getItem("member_id")})
                }
            })
        }else {
            goodsauthtwo(userMemberId).then((res) => {
                Toast.hide()
                if(res.code != 1){
                    if(sessionStorage.getItem('url') === 'p1'){
                        route.push({pathname: '/p1',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }else if(sessionStorage.getItem('url') === 'p2' || localStorage.getItem('url') === 'p2'){
                        route.push({pathname: '/p2',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }else {
                        route.push({pathname: '/p3',search:"sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')})
                    }
                }else{
                    // window.gdt('track', 'RESERVATION', {'key1': 'value1', 'key2': 'value2'});
                    route.replace({pathname: '/result',search:"member_id=" + localStorage.getItem("member_id")})
                }
            })
        }
    }
    //重新支付
    function resetPay(){
        let hashUrl = window.location.hash
        let wxUrl = hashUrl.substring(hashUrl.indexOf('?') + 1)
        window.location.href = wxUrl;
    }
    return (
        <div>
            <Modal
                visible={payed}
                transparent={true}>
                <div className={style.title}>
                    请确认微信是否已支付完成
                </div>
                <button className={style.btn} onClick={payment}>已完成支付</button>
                {/* <button className={style.btn2} onClick={resetPay}>遇到问题重新支付</button> */}
            </Modal>
        </div>
    )
}
